import { ImageAttachment } from "source/app/features/checklists/checklist.interface";

export interface Action<T> {
	id: string;
	operator: string;
	location: string;
	when: string;
	actionType: ActionType;
	payLoad: T;
}

export enum ActionType {
	CREATE_DISPATCH = 0,
	UPDATE_QUEUE_TIME = 1,
	CREATE_NOTE = 2,
	SIGN_OUT = 3,
	CREATE_ASSET_DISPATCH = 4,
}

export interface CreateDispatchAction {
	riders: number;
	dispatchUnitCapacity: number;
	dispatchUnitsAvailable: number;
	totalUnavailableCapacity: number;
	dispatchDelayReason?: number;
}

// Per-unit asset dispatch payload for `create-asset-dispatch` (one Raven entry per tap).
export interface CreateAssetDispatchAction {
	asset: string;
	seats: number;
	occupiedSeats: number;
	unavailableSeats: number;
	delayReason?: number;
	emptyReason?: number;
}

export interface UpdateQueueTimeAction {
	queueTimeInMinutes: number;
}

export interface CreateNoteAction {
	type: string;
	description: string;
	attachments: ImageAttachment[];
	title?: string;
}
